/*
 * Delta Don — global atmosphere behaviours.
 *
 * Loaded once via snippets/scripts.liquid (wired by the coordinator).
 * Currently owns one behaviour: a 2px scroll-progress hairline fixed to the
 * top of the viewport (.dd-atmo-scroll-progress, styled in dd-atmosphere.css).
 *
 * The bar is transform-only (scaleX), updated at most once per frame from a
 * passive scroll listener. It mirrors the visitor's own scroll position — it
 * is not autonomous motion — but it is still disabled entirely when reduced
 * motion is requested (and removed again if the preference changes at
 * runtime). No scroll behaviour is modified: no scrolljacking, no smooth-
 * scroll hijinks.
 */
(() => {
  const CLASS = 'dd-atmo-scroll-progress';
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  let bar = null;
  let ticking = false;

  const update = () => {
    ticking = false;
    if (!bar) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const progress = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
    bar.style.transform = `scaleX(${progress})`;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const mount = () => {
    if (bar) return;
    bar = document.createElement('div');
    bar.className = CLASS;
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  };

  const unmount = () => {
    if (!bar) return;
    window.removeEventListener('scroll', requestUpdate);
    window.removeEventListener('resize', requestUpdate);
    bar.remove();
    bar = null;
    ticking = false;
  };

  const sync = () => {
    if (motionQuery.matches) {
      unmount();
    } else {
      mount();
    }
  };

  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', sync);
  }

  sync();
})();
